import { createContext, useContext } from "react";

export const ThemeContext = createContext({
  effectiveTheme: "light",
  themeMode: "auto"
});

export const ThemeProvider = ThemeContext.Provider;

export const useThemeContext = () => useContext(ThemeContext);
